//import utc from './utc.js';

export default{
    install(Vue){
        Vue.prototype.$utc = function(dateText, dateType) { return timezone (dateText, dateType) }
    }
}


function timezone (dateText, dateType) { 
    if (dateText == undefined) return " ";
    switch(dateType) { 
		//case "yyyy-MM-dd HH:mm": return dateTimezone(new Date(dateText + "T00:00:00Z"), dateType, ""); break; 
        //case "yyyy-MM-dd HH:mm ADD1DAY": return dateTimezone(new Date(dateText + "T00:00:00Z"), dateType, "ADD1DAY"); break; 
		case "yyyy-MM-dd HH:mm:ss": return dateTimezone(new Date(dateText.split(" ")[0] + "T" + dateText.split(" ")[1] + "Z"), dateType, ""); break; 
        case "yyyy-MM-dd HH:mm": return dateTimezone(new Date(dateText.split(" ")[0] + "T" + dateText.split(" ")[1] + ":00Z"), dateType, ""); break; 
		default: return " "; 
	} 
}

function dateTimezone (date, dateType, option) {
    if (!date.valueOf()) return " ";
    var weekKorName = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
    var weekKorShortName = ["일", "월", "화", "수", "목", "금", "토"];
    var weekEngName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var weekEngShortName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    if (option == "ADD1DAY") date.setDate(date.getDate() + 1)
    var d = date;
    return dateType.replace(/(yyyy|yy|MM|dd|KS|KL|ES|EL|HH|hh|mm|ss|a\/p|ADD1DAY)/gi, function ($1) {
        switch ($1) {
			case "yyyy": return d.getFullYear(); 
            case "yy": return ((d.getFullYear() % 1000)<10)?"0"+(d.getFullYear() % 1000).toString():(d.getFullYear() % 1000).toString(); 
            case "MM": return ((d.getMonth() + 1)<10)?"0"+(d.getMonth() + 1).toString():(d.getMonth() + 1).toString(); 
            case "dd": return (d.getDate()<10)?"0"+d.getDate().toString():d.getDate().toString(); 
            case "KS": return weekKorShortName[d.getDay()]; 
            case "KL": return weekKorName[d.getDay()]; 
            case "ES": return weekEngShortName[d.getDay()]; 
            case "EL": return weekEngName[d.getDay()]; 
            case "HH": return (d.getHours()<10)?"0"+d.getHours().toString():d.getHours().toString(); 
            case "hh": return (((h = d.getHours() % 12) ? h : 12)<10)?"0"+((h = d.getHours() % 12) ? h : 12).toString():((h = d.getHours() % 12) ? h : 12).toString(); 
            case "mm": return (d.getMinutes()<10)?"0"+d.getMinutes().toString():d.getMinutes().toString(); 
            case "ss": return (d.getSeconds()<10)?"0"+d.getSeconds().toString():d.getSeconds().toString(); 
            case "a/p": return d.getHours() < 12 ? "오전" : "오후"; 
            case "ADD1DAY": return ""; 
            default: return $1;
            
        }
    });
}



// WEBPACK FOOTER //
// ./src/assets/js/utc.js